import { Type, Static } from '@sinclair/typebox'

import { NumberMinZeroDefaultUndefinedTB } from './report_shared';

export const FurtherProcessorPurchasedGoodsTB = Type.Object({
  dry: NumberMinZeroDefaultUndefinedTB(),
  pork: NumberMinZeroDefaultUndefinedTB(),
  egg: NumberMinZeroDefaultUndefinedTB(),
  plasticPackaging: NumberMinZeroDefaultUndefinedTB(),
  cardboardPackaging: NumberMinZeroDefaultUndefinedTB(),
  processingAids: NumberMinZeroDefaultUndefinedTB(),
  canolaOil: NumberMinZeroDefaultUndefinedTB()
})
export type FurtherProcessorPurchasedGoodsT = Static<typeof FurtherProcessorPurchasedGoodsTB>;
